import { Component, Prop, Vue } from "vue-property-decorator";
import Check from "@/packages/check";
import { VNode } from "vue";
import { BaseAgreementData } from "./base-agreement-data";

const style = require("./index.module.scss");

@Component({ name: "BasicAgreements" })
export class BasicAgreements extends Vue {
  @Prop({
    type: String,
    default: "我同意",
  })
  protected prefix!: string;

  @Prop() public status!: BaseAgreementData;

  protected clickItem(index: number): void {
    this.$emit("clickItem", index);
  }

  protected render(): VNode | null {
    if (this.status && this.status.items && this.status.items.length) {
      return (
        <div class={style.agreement}>
          <Check v-model={this.status.checked} mode="radio" parentClick />
          <p class={style.agreementP}>
            {this.prefix}
            {this.status.items.forEach((item, index) => (
              <span onclick={this.clickItem.bind(this, index)}>
                {item.name}
              </span>
            ))}
          </p>
        </div>
      );
    }

    return null;
  }
}
